<template>
    <div class="metric-goal-modal">
        <b-modal body-class="light-bg"
                 size="lg"
                 :id="modalId"
                 @shown="shown"
                 @ok="ok">
            <template v-slot:modal-header>
                <h5>{{ title }}</h5>
            </template>
            <b-row>
                <b-col>

                    <b-form-radio-group
                        buttons
                        class="buttons-value"
                        v-model="selectedMetric"
                        :stacked="true">

                        <b-form-radio
                            class="mb-0 hide-radio-button buttons-value__label"
                            value="WEIGHT">
                            {{metricLabels['WEIGHT']}}: {{ valueString('WEIGHT') }}
                        </b-form-radio>

                        <b-form-radio
                            class="mb-0 hide-radio-button buttons-value__label"
                            value="ACTIVITY">
                            {{metricLabels['ACTIVITY']}}: {{ valueString('ACTIVITY') }}
                        </b-form-radio>

                    </b-form-radio-group>

                </b-col>
                <b-col>
                    <b-form
                        @submit.prevent
                        v-if="selectedMetric != ''"
                        :label="metricLabels[selectedMetric]">

                        <span>
<!--                        I would like my weight/steps to be ...-->
                           {{$i18n.gt('LABEL_METRIC_GOAL_MODAL_PHRASE_ONE').replace('{metric_name}', metricLabels[selectedMetric].toLowerCase())}}
                        </span>
                        <b-input-group
                            :append="unitLabels[selectedMetric]">
                            <b-form-input type="number" v-model="model[selectedMetric].value"></b-form-input>
                        </b-input-group>
                        <span>
                           {{$i18n.gt('LABEL_METRIC_GOAL_MODAL_PHRASE_TWO')}}
                        </span>
                        <b-form-input type="date" v-model="model[selectedMetric].date"></b-form-input>
                    </b-form>
                </b-col>
            </b-row>
        </b-modal>

    </div>

</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import * as _ from 'lodash'
import MetricUtil from "@/providers/Metrics"

export default Vue.extend({
    name: "MetricGoalModal",
    props: {
        modalId: String,
        title: String,
        metrics: Array,
        service: String,
        onSubmit: Function, //Requires a parameter to pass entries
    },
    data() {
        return {
            selectedMetric: "WEIGHT",
            model: {
                ACTIVITY: {date: null, value: null},
                WEIGHT: {date: null, value: null},
            },
            metricUtil: MetricUtil,
            unitLabels: MetricUtil.unitLabels(),
            //metricLabels: MetricUtil.metricLabels(),
        }
    },
    computed: {
      metricLabels() {
        return MetricUtil.metricLabels()
      }
    },
    methods: {
        ok(evt) {
            let entries = this.modelToEntries()
            this.onSubmit(entries)
        },
        fillModel() {
            _.forEach(this.metrics, (metric) => {
                if (metric.service == this.service &&
                    (metric.metric == 'ACTIVITY' || metric.metric == 'WEIGHT')) {
                    _.forEach(metric.readings, (reading) => {
                        this.model[metric.metric] = {
                            date: reading.value.dateTime,
                            value: reading.value.value
                        }
                    })
                }
            })
        },
        modelToEntries() {

            let entries = this.model
            _.forEach(this.model, (value, metric) => {
                if (value.date && value.value) {
                    entries[metric] = {[value.date]: value.value}
                } else {
                    entries[metric] = {}
                }
            })

            return entries
        },
        valueString(metric) {
            return this.model[metric].value ?
                this.model[metric].value + ' ' + this.unitLabels[metric] : ' - '
        },
        shown() {
            this.fillModel()

            this.$forceUpdate()
        },
    },
})
</script>
<style lang="scss">

@import '../../sass/variables_mixins';

.buttons-value {
    width: 100%;

    .input-group-append {
        width: 30%;
    }

    .input-group-text {
        width: 100%;
    }

    button:focus {
        outline: none;
    }
}

.buttons-value__label {
    font-weight: bold !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    width: 70%;

    &.active {
        background-color: var(--btn-bg-hover) !important;
        border-color: var(--btn-bg-hover) !important;
    }

    &:focus, &.focus {
        outline: none !important;
        @include box-shadow(none !important);
    }
}

.active {
    .buttons-value__values, .buttons-value__label {
        color: #fff;
    }
}

.inputs-value {
    .form-control {
        color: #222;
    }
}

</style>
<style>

.hide-radio-button input[type="radio"] {
    opacity: 0;
    position: fixed;
    width: 0;
}
</style>
